import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

/**
 * One option of a radio group, laid out like `app-dl-checkbox`: the label on the left, its
 * description beside it. Every option of a group is its own `app-dl-radio`, all bound to the
 * group's value (`[ngModel]`) and sharing a `name`; an option is selected while the model equals
 * its `value`.
 */
@Component({
  selector: 'app-dl-radio',
  templateUrl: './dl-radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DlRadioComponent),
      multi: true
    }
  ]
})
export class DlRadioComponent implements ControlValueAccessor {
  @Input() radioId: string;
  @Input() name: string;
  @Input() value: unknown;
  @Input() label: string;
  @Input() description: string;
  @Input() required = false;
  @Input() invalid = false;

  /** The group's current value, as last written by the model. */
  selected: unknown = null;
  disabled = false;

  private onChange: (v: unknown) => void = () => {};
  private onTouched: () => void = () => {};

  get checked(): boolean {
    return this.selected === this.value;
  }

  writeValue(value: unknown): void {
    this.selected = value;
  }

  registerOnChange(fn: (v: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(): void {
    this.selected = this.value;
    this.onChange(this.value);
    this.onTouched();
  }
}
